// removed by extract-text-webpack-plugin
module.exports = {"draggablePart":"theme__draggablePart___3KC-7","dragging":"theme__dragging___3HB7p"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Builder/DraggablePart/theme.scss
// module id = 1287
// module chunks = 0